import { Link } from 'react-router-dom';
import { categoryComics, categoryCoverImages } from '@/mocks/category';

interface ComicGridProps {
  slug: string;
}

const placeholderImage = 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20generic%20cover%20style%2C%20simple%20clean%20composition%2C%20warm%20neutral%20tones%2C%20Korean%20webtoon%20art%20style&width=400&height=560&seq=placeholder-comic&orientation=portrait';

export default function ComicGrid({ slug }: ComicGridProps) {
  const filtered = categoryComics.filter((c) => c.category === slug);
  const allComics = filtered.length > 0 ? filtered : categoryComics;

  return (
    <section className="w-full bg-background-100 py-12 md:py-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            全部作品
          </h2>
          <div className="flex items-center gap-2">
            <span className="text-xs text-foreground-500">排序：</span>
            <select className="text-xs bg-white border border-secondary-200 rounded-md px-2 py-1.5 text-foreground-700 cursor-pointer focus:outline-none focus:border-accent-500">
              <option>热门优先</option>
              <option>最新更新</option>
              <option>评分最高</option>
            </select>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {allComics.map((comic) => (
            <Link
              key={comic.id}
              to={`/article/${comic.id}`}
              className="group block rounded-lg overflow-hidden cursor-pointer"
            >
              <div className="relative aspect-[3/4] overflow-hidden bg-secondary-100">
                <img
                  src={categoryCoverImages[comic.id] || placeholderImage}
                  alt={comic.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                <div className="absolute top-2 right-2">
                  <span className="px-2 py-0.5 rounded-full bg-accent-500 text-white text-xs font-medium">
                    {comic.rating}
                  </span>
                </div>
              </div>
              <div className="bg-white py-3 px-2">
                <h4 className="font-semibold text-foreground-950 text-sm truncate">{comic.title}</h4>
                <div className="flex items-center justify-between mt-1">
                  <span className="text-foreground-500 text-xs">{comic.author}</span>
                  <span className="text-foreground-400 text-xs">{comic.status}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}